import { ButtonPresentationProps } from "@insite/mobius/Button";
import { css } from "styled-components";

export const buttonGetHoverProps = (color: string): ButtonPresentationProps => ({
    hoverStyle: { color },
    activeStyle: { color },
});

export const buttonGetColorProps = (color: string, hoverColor?: string): ButtonPresentationProps => ({
    color,
    ...buttonGetHoverProps(hoverColor || color),
});

export enum ButtonColorPreset {
    Invert = "invert",
}

export const buttonGetColorPreset = (preset: ButtonColorPreset): ButtonPresentationProps => {
    switch (preset) {
        case ButtonColorPreset.Invert:
            return buttonGetColorProps("invert", "invert.dark");
        default:
            return {};
    }
};

export const buttonResetProps: ButtonPresentationProps = {
    color: undefined,
    buttonType: undefined,
    css: css`
        min-width: 0;
        min-height: 0;
        padding: 0;
        border: 0;
        background-color: transparent;
    `,
};
